export default function doMegaMenus() {
	const previews = document.querySelectorAll('.fndry-mega-menu-preview');
	const menus = document.querySelectorAll('.fndry-nav__item--has-submenu > .fndry-nav-submenu');

	if (previews && menus) {
		menus.forEach((menu, i) => {
			if (!previews[i]) {
				return;
			}
			const inner = menu.innerHTML;
			const newWrapper = document.createElement('div');
			newWrapper.classList.add('fndry-nav-submenu');
			newWrapper.innerHTML = `<div class='fndry-nav-submenu__preview'></div><ul>${inner}</ul>`
			menu.parentElement.replaceChild(newWrapper, menu);
			newWrapper.querySelector('.fndry-nav-submenu__preview').appendChild(previews[i])
		})
	}
}
